/**
 * @file main.tab.tsx
 * @description Основная таба формы функционального требования (functional-requirement).
 * Предназначена для создания детального описания функциональных требований к системе или продукту.
 * Позволяет документировать спецификации, требования к поведению и сценарии использования с поддержкой rich text форматирования и вложений.
 * Поддерживает drag-and-drop загрузку файлов через DragNDropZone.
 * @author AI Assistant
 * @created 2025-09-04
 * @updated 2025-09-04
 * @dependencies [react, @src/types, @components/form-controls/drag-n-drop-zone, @components/form-controls/collapsed/attachments-rich-text]
 * @related-files [@forms/functional-requirement/functional-requirement.form.tsx, @components/form-controls/collapsed/attachments-rich-text/attachments-rich-text.component.tsx]
 */

import { tabProps } from '@src/types';
import { DragNDropZone } from '@components/form-controls/drag-n-drop-zone';
import { AttachmentsRichText } from '@components/form-controls/collapsed/attachments-rich-text';

export const Main = ({ control }: tabProps) => {
    return (
        <DragNDropZone className="flex flex-col h-full gap-[1.0585vmin]" name="attachments" control={control}>
            <AttachmentsRichText
                label="Описание"
                name="description"
                control={control}
                placeholder="Добавьте описание задачи, чтобы исполнителю было понятно, что нужно сделать в рамках задачи"
            />
        </DragNDropZone>
    );
};
